/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Divider, Spin, Table, Tag, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import IconExpand from '../../../../assets/Images/icons/icon-expandClass';
import ConsentService from '../../../../services/Consent.service';
import ModalAcceptance from './ModalAcceptance';
import { getTagAction } from '../../../../util/util';
import moment from 'moment';
import UserManagementService from '../../../../services/UserManagement.service';
import UserService from '../../../../services/UserService';
function Card({ item, getDetailConsent }) {
    const ownerId = UserService.getUi();
    const { i18n, t } = useTranslation();
    const lang = i18n.language;
    const { id } = useParams();
    const [form] = Form.useForm();
    const [historyList, setHistoryList] = useState([]);
    const [username, setUsername] = useState();
    const [total, setTotal] = useState(0);
    const [expand, setExpand] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const getHistoryDetail = async () => {
        try {
            const { data } = await ConsentService.getDetailConsent({
                identity: id,
                consentTxnGroupId: item?.consentTxnGroupId,
            });
            const items = data?.resultData?.history;
            await setHistoryList(items);
            await setTotal(items?.length);
        } catch (error) {}
    };

    const getUserDetail = async (id) => {
        try {
            const { data } = await UserManagementService.getUserDetail(id);
            const item = data?.resultData;
            if (item) {
                setUsername(`${item.fname} ${item.lname}`);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getHistoryDetail();
        getUserDetail(ownerId);
    }, []);

    const _getTagDay = (e) => {
        if (e <= 0) {
            return (
                <Tag className="rounded-xl -my-1" color="#F0536F">
                    {e}
                </Tag>
            );
        } else if (e <= 7) {
            return (
                <Tag className="rounded-xl -my-1" color="#F9C153">
                    {e}
                </Tag>
            );
        } else {
            return (
                <Tag className="rounded-xl -my-1" color="#1890FF">
                    {e}
                </Tag>
            );
        }
    };
    const History = ({ result }) => {
        const columns = [
            {
                title: t('Consent.ConsentDate'),
                dataIndex: 'consentDate',
                key: 'consentDate',
            },
            {
                title: t('Consent.Version'),
                dataIndex: 'version',
                key: 'version',
            },
            {
                title: t('Consent.Status'),
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                render: (status) => getTagAction(status),
            },
            {
                title: t('Consent.CollectionPointName'),
                dataIndex: 'collectionPointName',
                key: 'collectionPointName',
                render: (text) => (text ? text : '-'),
                className: 'min-w-[200px]',
            },
            {
                title: t('Consent.UpdateBy'),
                dataIndex: 'updateBy',
                key: 'updateBy',
            },
            {
                title: t('Consent.LastUpdate'),
                dataIndex: 'updateDate',
                key: 'updateDate',
            },
        ];
        return (
            <div className="">
                <Table
                    rowKey={(record) => record?.historyId}
                    className="inbox_table"
                    dataSource={result || []}
                    columns={columns}
                    pagination={false}
                    scroll={{
                        y: 252,
                    }}
                />
            </div>
        );
    };

    return (
        <>
            <Spin spinning={!historyList}>
                <div key={item.consentTxnGroupId} className="card px-7 pb-0">
                    <div className="flex justify-between items-center">
                        <div className="w-[480px] text-sm text-[#7B67FB] font-semibold">
                            {lang === 'en'
                                ? item?.consentNameEn
                                : item?.consentNameTh}
                        </div>
                        <div className="text-sm flex items-center gap-2">
                            <div>
                                <span className="font-semibold">
                                    {t('Consent.LastStatus')} :&nbsp;
                                </span>
                                {t(`COOKIE.${item.status}`)}
                            </div>
                            <Button
                                onClick={() => {
                                    setOpenModal(true);
                                    form.setFieldsValue({
                                        isAccept:
                                            item?.status === 'Accepted'
                                                ? true
                                                : false,
                                        consentDate: moment(
                                            new Date(),
                                            'DD/MM/YYYY HH:mm'
                                        ),
                                    });
                                }}
                                size="large"
                                type="primary"
                            >
                                {t('Consent.Reconsent')}
                            </Button>
                        </div>
                    </div>
                    <Divider className="my-4" />
                    <div className="grid grid-cols-2 mt-2">
                        <div className="space-y-2">
                            <div className="grid grid-cols-4 text-xs">
                                <strong className="text-xs col-span-1">
                                    {t('Consent.ConsentType')} :
                                </strong>
                                <div className="col-span-3">
                                    {item?.consentType || '-'}
                                </div>
                            </div>
                            <div className="grid grid-cols-4 text-xs">
                                <strong className="text-xs col-span-1">
                                    {t('Consent.AcceptedVersion')} :
                                </strong>
                                <div className="col-span-3">
                                    {item?.acceptedVersion || '-'}
                                </div>
                            </div>
                            <div className="grid grid-cols-4 text-xs">
                                <strong className="text-xs col-span-1">
                                    {t('Consent.UsageStatus')} :
                                </strong>
                                <div className="col-span-3">
                                    <div className="flex items-center">
                                        <div className="mr-2">
                                            {item?.usageStatus || '-'}
                                        </div>
                                        <Tag
                                            hidden={!item?.newVersion}
                                            className="rounded-xl"
                                            color="#1890FF"
                                        >
                                            {t('Consent.NewVersion')}
                                        </Tag>
                                        <Tag
                                            hidden={!item?.isExpire}
                                            className="rounded-xl"
                                            color="#1890FF"
                                        >
                                            {t('Consent.Expired')}
                                        </Tag>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-2">
                            <div className="grid grid-cols-4 text-xs">
                                <strong className="text-xs col-span-1">
                                    {t('Consent.DayLeft')} :
                                </strong>
                                <div className="col-span-3">
                                    {_getTagDay(item?.dayLeft)}
                                </div>
                            </div>
                            <div className="grid grid-cols-4 text-xs">
                                <strong className="text-xs col-span-1">
                                    {t('Consent.ConsentDate')} :
                                </strong>
                                <div className="col-span-3">
                                    {item?.consentDate || '-'}
                                </div>
                            </div>
                            <div className="grid grid-cols-4 text-xs">
                                <strong className="text-xs col-span-1">
                                    {t('Consent.LastUpdate')} :
                                </strong>
                                <div className="col-span-3">
                                    {item?.updateDate || '-'}
                                </div>
                            </div>
                            <div className="grid grid-cols-4 text-xs">
                                <strong className="text-xs col-span-1">
                                    {t('Consent.UpdateBy')} :
                                </strong>
                                <div className="col-span-3">
                                    {item?.updateBy || '-'}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Divider className="my-4" />
                    <div className="font-semibold text-base mb-4">
                        {t('Consent.History')} ( {total} )
                    </div>

                    {expand && <History result={historyList} />}
                    <div className="flex-column">
                        <Divider className="mb-0 mt-4" />
                        <div
                            className="flex justify-center items-center gap-1 cursor-pointer transition"
                            onClick={() => {
                                setExpand(!expand);
                            }}
                        >
                            <div className="">
                                <div
                                    className={`w-full text-center py-3 transition-all duration-300
                        ${expand && 'rotate-180'}`}
                                >
                                    <IconExpand />
                                </div>
                            </div>
                            <div>
                                {expand ? 'Collapse' : 'Expand'} History Info.
                            </div>
                        </div>
                    </div>
                </div>
            </Spin>
            <ModalAcceptance
                open={openModal}
                handelClose={() => setOpenModal(false)}
                detailConsentData={item}
                getDetailConsent={getDetailConsent}
                getHistoryDetail={getHistoryDetail}
                username={username}
                form={form}
            />
        </>
    );
}
export default Card;
